import { useTranslation } from "react-i18next";
import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getHistoryEditScore } from '../../../../../../service/test-schedule';
import dayjs from 'dayjs';
type Props = {
	handleCancel: () => void,
	open: boolean,
}

const HistoryEditScoreModal = (props: Props) => {
  const { t } = useTranslation();
	const { handleCancel, open } = props;
	const { blockId, classId } = useParams()
	const [historyEditScore, setHistoryEditScore] = useState<any>([])

	useEffect(() => {
		const fetchHistoryEditScore = async () => {
			try {
				const res = await getHistoryEditScore(Number(blockId), Number(classId))
				setHistoryEditScore(res?.data.data)
			} catch (error) {

			}
		}
		if (open) fetchHistoryEditScore()
	}, [open, blockId])
	return (
		<Drawer title={t("Lịch sử chỉnh sửa điểm", "Lịch sử chỉnh sửa điểm")} onClose={handleCancel} open={open}>
			{historyEditScore?.map((it: any, index: number) => {
				return (
					<div key={it.id} className='flex p-3 font-size-14 '>
						<div
							style={{ width: "20px" }}
						>
							{++index}
						</div>
						<p>{t("Chỉnh sửa lúc:", "Chỉnh sửa lúc:")} {dayjs(it.createdDate).format("HH:mm DD/MM/YYYY")} {t("bởi", "bởi")} <b>{it?.name}</b></p>
					</div>
				)
			})}
		</Drawer>
	)
}

export default HistoryEditScoreModal